import { COOKIE_ORDER, formatCookieString } from '../cookies'
import { type AccountData } from '../models'

export function formatIam(account: AccountData): string {
  const cookiesNoAuth: Record<string, string> = {}
  for (const [k, v] of Object.entries(account.cookies)) {
    if (k !== 'Authorization') cookiesNoAuth[k] = v
  }

  let cookieStr = formatCookieString(cookiesNoAuth, COOKIE_ORDER)
  const auth = account.cookies.Authorization
  if (auth) {
    const authPart = `Authorization=${auth}`
    cookieStr = cookieStr ? `${cookieStr};${authPart}` : authPart
  }

  let email = ''
  if (account.emailLogin) {
    email = account.emailPassword
      ? `${account.emailLogin}:${account.emailPassword}`
      : account.emailLogin
  }

  return `${account.login}:${account.password}:${account.twofaKey}|${account.userAgent}|${account.androidId}|${cookieStr}|${account.proxy}|${email}`
}
